import type {VoidFunctionComponent} from "react";
import React from "react";
import s from "./TranscriptionProgress.module.scss";
import {useAppSelector} from "../../../redux/hooks";
import {lessonPlayerStore} from "../../../redux/lesson/LessonPlayerStore";

export const TranscriptionProgressModal: VoidFunctionComponent = () => {
  const percent = useAppSelector(lessonPlayerStore.getTranscriptionProgressPercentage);
  const status = useAppSelector(lessonPlayerStore.getTranscriptionStatus);

  if (status === 'completed') {
    // But what happens if transcription fails at 50%?
    return null;
  }

  const displayedPercentage = (parseInt(percent) > 0) ? percent + '%' : '';

  return (
    <div className={s.backdrop}>
      <div className={s.dialog} role={"dialog"}>
        <div className={s.message}>Analyzing your playing...</div>
        <progress className={s.progressBar} max="100" value={percent}/>
        <div className={s.percentage}>{displayedPercentage}</div>
      </div>
    </div>
  );
}
